export const checkIfImageExist = (item, { isApod } = {}) => {
  if (isApod && item?.preview_image) {
    return [item.preview_image];
  }

  let isImage = item.preview_image ? item.preview_image.search("image") : 0;
  if (isImage > 1) {
    return [item.preview_image];
  }

  return item.catalog?.images || [];
};

export const formatProductsList = (productsList, { isApod } = {}) => {
  return [
    ...(productsList &&
      productsList?.map((item) => ({
        id: item.id,
        listing_id: item.listing_id ? item.listing_id : null,
        amazon_sku: item.amazon_sku ? item.amazon_sku : null,
        cover: checkIfImageExist(item, { isApod }),
        images: checkIfImageExist(item, { isApod }),
        uploadedData: item.graphic_image,
        notecardData: item.notecard_image,
        name:
          item.title === "undefined"
            ? item.catalog?.title
            : item.title,
        desc: item?.catalog?.description,
        price: item.price,
        shipPrice: item.catalog?.shipping_price,
        catalog: item.catalog,
        no_of_graphics: item?.catalog?.no_of_graphics,
        etsy_product_skus: item?.etsy_product_skus,
        breadCrumb: "products",
        ...item,
        ...(isApod
          ? {
              is_apod: 1,
              title:
                !item.title || item.title === "undefined"
                  ? item.catalog?.title || item.name || ""
                  : item.title,
            }
          : {}),
      }))),
  ];
};
